import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import AuthContext from '../../../context/authContext';
import useHttp from '../../../hooks/useHttp';

// Loads the entertainment list once for the flow builder settings panels.
export default function useEntertainmentOptions() {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();
  const [entertainments, setEntertainments] = useState([]);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const response = await sendRequest({
          url: '/api/v1/entertainment',
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
          params: { light: true },
        });
        if (!active) return;
        setEntertainments(response?.entertainments || response || []);
      } catch {
        if (active) toast.error('Fehler beim Laden der Entertainments.');
      }
    };
    load();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return entertainments;
}
